import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
//TODO: Duplicate code fetchFieldOfSelectedCollection
export const fetchFieldOfSelectedCollection = async (
  projectId,
  version,
  filteredCollection,
  name,
  value,
) => {
  return getItemsOfSelectedCollection(projectId, filteredCollection.collectionName, version)
    .then((response) => {
      const selectedCollectionFieldItems = response.data;
      const selectedCollectionFields = [];
      const selectedCollectionFilters = [];
      filteredCollection.fields.forEach((field) => {
        selectedCollectionFields.push({
          name: field.fieldTitle.en,
          uuid: field._id,
          value: field.fieldName,
          type: field.type,
          refCollection: field.refCollection ? field.refCollection : '',
          staticOptions: field.staticOptions ? field.staticOptions : [],
        });
      });

      filteredCollection.finders.forEach((finder) => {
        selectedCollectionFilters.push({
          value: finder.uuid,
          label: finder.name,
        });
      });
      const returnObj = {
        selectedCollectionFields,
        [name]: value,
        selectedCollectionFieldItems,
        selectedCollectionFilters,
      };

      return returnObj;
    })
    .catch((err) => {
      console.log('err :>> ', err);
    });
};
export const getItemsOfSelectedCollection = async (
  projectId,
  collectionName,
  version,
  fieldsToInclude = [],
) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  let params = '';
  if (fieldsToInclude.length) {
    fieldsToInclude.push('uuid');
    fieldsToInclude = fieldsToInclude.map((field) => `project_${field}=true`);
    params = fieldsToInclude.join('&');
  }
  return await axios.get(
    `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/${
      params ? '?' + params : ''
    }`,
    header,
  );
};
